import React from 'react';
import { SlidePage } from '../index';
import { BodyContainer, ProgressBox, ProgressStat } from '../styles';
import { polarColors } from '../constants';

const getColor = value => {
  if (value < 25) {
    return polarColors[4];
  }
  if (value < 50) {
    return polarColors[3];
  }
  if (value < 75) {
    return polarColors[1];
  }
  return polarColors[0];
};

const VocationalMaturityThirdPage = ({ user, background, number }) => {
  const infoSobreSiMismo = parseFloat(user['Información sobre el Self']);
  const infoSobreOcupaciones = parseFloat(
    user['Información sobre Ocupaciones']
  );
  return (
    <SlidePage number={number} background={background}>
      <BodyContainer>
        <div className='content'>
          <h3 style={{ marginBottom: '0.5rem' }}>
            Falta de información sobre ocupaciones.{' '}
          </h3>
          <p className='justified'>
            Esta carencia de datos específicos y claros sobre profesiones y
            campos laborales es una{' '}
            <strong>barrera común en la toma de decisiones vocacionales</strong>
            . Es natural sentirse abrumado o abrumada por la cantidad de
            carreras y especializaciones disponibles en la actualidad. La falta
            de claridad puede surgir al intentar comprender la estructura y
            contenidos de los programas académicos, o al visualizar las
            posibilidades laborales de una carrera en particular.
          </p>
          <p className='justified'>
            Las preguntas típicas que se podrían formular incluyen: ¿Qué
            disciplinas o materias específicas componen la malla de las carreras
            que me atraen? ¿Qué tipo de trabajos puedo esperar obtener una vez
            graduado, y en qué contextos laborales? ¿Cuál es la demanda actual
            para profesionales en ese campo y cómo podría evolucionar en el
            futuro?
          </p>
          <div className='paragraph'>¿Cómo afrontar esta situación?</div>
          <ul className='text-list'>
            <li>- Entrevistas informativas.</li>
            <li>- Prácticas, pasantías o ir de oyente a una clase.</li>
            <li>- Asistir a ferias de educación superior.</li>
            <li>- Investigación online.</li>
          </ul>
          <br />
          <div className='progress-info-group'>
            <div className='progress-info'>
              <div className='progress-details-single'>
                {/* <div className='progress-name'>
                  Falta de información sobre ocupaciones
                </div> */}
                <ProgressBox
                  progress={infoSobreOcupaciones}
                  backColor={() => getColor(infoSobreOcupaciones)}
                >
                  <div className='progress'></div>
                </ProgressBox>
                <ProgressStat>{infoSobreOcupaciones}</ProgressStat>
              </div>
            </div>
          </div>
          <br />

          <h3 style={{ marginBottom: '0.5rem' }}>
            Falta de información sobre Sí mismo.{' '}
          </h3>
          <p className='justified'>
            A menudo,{' '}
            <strong>
              la falta de autoconocimiento puede ser uno de los obstáculos más
              desafiantes al tomar decisiones vocacionales
            </strong>
            . Esta desconexión puede manifestarse como una incertidumbre sobre
            cuáles son tus habilidades genuinas, qué te motiva o cuáles son tus
            auténticos intereses. ¿Cuáles son mis habilidades e intereses? ¿Qué
            me gusta?
          </p>
          {/* <p className='justified'>
            Por ejemplo, si siempre te han felicitado en matemáticas, pero, no
            estás seguro/a de si realmente te gusta esta materia o si
            simplemente eres bueno/a en ella porque siempre has sido
            incentivado/a por tus profesores y padres. Esta confusión te lleva a
            dudar si realmente querrías seguir una carrera en ingeniería o
            matemáticas aplicadas.
          </p> */}
          <div className='paragraph'>¿Cómo afrontar esta situación?</div>
          <ul className='text-list'>
            <li>- Ayuda profesional (coach vocacional).</li>
            <li>
              - Autoevaluación guiada (uso de test o encuestas para medir tus
              fortalezas, debilidades, intereses, etc.).
            </li>
            <li>
              - Diarios de reflexión (escribe tus experiencias, sentimientos y
              reflexiones que puedan ayudar a conocerte más).
            </li>
          </ul>
          <br />
          <div className='progress-info-group'>
            <div className='progress-info'>
              <div className='progress-details-single'>
                {/* <div className='progress-name'>
                  Falta de información sobre Sí mismo
                </div> */}
                <ProgressBox
                  progress={infoSobreSiMismo}
                  backColor={() => getColor(infoSobreSiMismo)}
                >
                  <div className='progress'></div>
                </ProgressBox>
                <ProgressStat>{infoSobreSiMismo}</ProgressStat>
              </div>
            </div>
          </div>
          <br />
        </div>
      </BodyContainer>
    </SlidePage>
  );
};

export default VocationalMaturityThirdPage;
